import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./viewEvents.css";
import { viewEvent } from "../../Redux/Actions/eventActions";
import { ToFirstCapital } from "../../Utils/helpers";

const ViewEvents = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [foundEvent, setFoundEvent] = useState({});
  const { event } = useSelector((state) => state.events);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  useEffect(() => {
    dispatch(viewEvent(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (event?.data) {
      setFoundEvent(event.data);
    }
  }, [event]);

  const formatDate = (dateString) => {
    if (!dateString) return "No Data";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    const statusColors = {
      active: 'status-active',
      completed: 'status-completed',
      upcoming: 'status-upcoming',
      cancelled: 'status-cancelled'
    };
    return statusColors[status?.toLowerCase()] || 'status-default';
  };

  const isTrailer = foundEvent?.type?.toLowerCase() === 'trailer';
  const hasGuests = !isTrailer && foundEvent?.guest_list && foundEvent.guest_list.length > 0;

  return (
    <div className="view-events-wrapper">
      <div className="professional-header">
        <div className="header-top" style={{ marginLeft: "42%" }}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

        <div className="header-main">
          <div className="header-left">
            <Link to="/news_and_articles">
              <BackIcon style={{ cursor: "pointer" }} />
            </Link>
            <div className="title-section">
              <h1 className="page-title">{foundEvent?.event_name || "Event Details"}</h1>
              <div className="breadcrumb">
                <span className="breadcrumb-item">Events</span>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-item">List</span>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-item current">View Details</span>
              </div>
            </div>
          </div>
          <div className="header-right">
            {foundEvent?.status && (
              <div className={`status-pill ${getStatusColor(foundEvent.status)}`}>
                <span className="status-dot"></span>
                {ToFirstCapital(foundEvent.status)}
              </div>
            )}
            {canEdit &&
              <Link to={`/event/edit/${id}`} className="primary-button">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M11.334 2.00004C11.5091 1.82494 11.7169 1.68605 11.9457 1.59129C12.1745 1.49653 12.4197 1.44775 12.6673 1.44775C12.9149 1.44775 13.1601 1.49653 13.3889 1.59129C13.6177 1.68605 13.8256 1.82494 14.0007 2.00004C14.1757 2.17513 14.3146 2.383 14.4094 2.61178C14.5042 2.84055 14.5529 3.08575 14.5529 3.33337C14.5529 3.58099 14.5042 3.82619 14.4094 4.05497C14.3146 4.28374 14.1757 4.49161 14.0007 4.66671L5.00065 13.6667L1.33398 14.6667L2.33398 11L11.334 2.00004Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Edit Event
              </Link>
            }
          </div>
        </div>
      </div>

      <div className="view-events-container">
        <div className="hero-section">
          <div className="hero-media">
            {foundEvent?.cover_photo && (
              <div className="hero-image">
                <img src={foundEvent.cover_photo} alt="Event Cover" />
                <div className="hero-overlay"></div>
              </div>
            )}

            {!foundEvent?.cover_photo && isTrailer && (
              <div className="hero-image" style={{ background: "linear-gradient(135deg, #1e293b, #334155)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ textAlign: "center", color: "#94a3b8" }}>
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto 16px", opacity: "0.6" }}>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor" />
                  </svg>
                  <p style={{ fontSize: "16px", fontWeight: "600", margin: "0" }}>Trailer Preview</p>
                  <p style={{ fontSize: "13px", margin: "4px 0 0 0", opacity: "0.8" }}>Check out the videos below</p>
                </div>
                <div className="hero-overlay"></div>
              </div>
            )}

            {!foundEvent?.cover_photo && !isTrailer && (
              <div className="hero-image" style={{ background: "linear-gradient(135deg, #3b82f6, #2563eb)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ textAlign: "center", color: "#ffffff" }}>
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto 16px", opacity: "0.8" }}>
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54h4.68l-1.93-2.46 1.44-1.8h2.1V9h-3.54l1.93 2.45-1.93 2.46z" fill="currentColor" />
                  </svg>
                  <p style={{ fontSize: "16px", fontWeight: "600", margin: "0", color: "#ffffff" }}>Event Preview</p>
                  <p style={{ fontSize: "13px", margin: "4px 0 0 0", opacity: "0.9", color: "rgba(255, 255, 255, 0.8)" }}>Gallery below</p>
                </div>
                <div className="hero-overlay"></div>
              </div>
            )}
          </div>

          <div className="hero-content">
            <div className="media-thumbnails">
              {foundEvent?.event_image && (
                <div className="thumbnail-item">
                  <div className="thumbnail-label">Event Photo</div>
                  <img src={foundEvent.event_image} alt="Event" />
                </div>
              )}

              {foundEvent?.video && (
                <div className="thumbnail-item video-thumbnail">
                  <div className="thumbnail-label">Event Video</div>
                  <video src={foundEvent.video} controls />
                  <div className="play-icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <circle cx="16" cy="16" r="16" fill="rgba(255,255,255,0.9)" />
                      <path d="M12 10L22 16L12 22V10Z" fill="#1e293b" />
                    </svg>
                  </div>
                </div>
              )}

              {foundEvent?.trailer_videos && foundEvent.trailer_videos.length > 0 && (
                foundEvent.trailer_videos.map((trailer, index) => (
                  <div key={index} className="thumbnail-item video-thumbnail">
                    <div className="thumbnail-label">Trailer Video {index + 1}</div>
                    <video src={trailer.url} controls />
                    <div className="play-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <circle cx="16" cy="16" r="16" fill="rgba(255,255,255,0.9)" />
                        <path d="M12 10L22 16L12 22V10Z" fill="#1e293b" />
                      </svg>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        <div className="quick-info-grid">
          <div className="info-card">
            <div className="info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="info-content">
              <div className="info-label">Event Period</div>
              <div className="info-value">{formatDate(foundEvent?.start_date)}</div>
              <div className="info-subvalue">to {formatDate(foundEvent?.end_date)}</div>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 13.43C13.7231 13.43 15.12 12.0331 15.12 10.31C15.12 8.58687 13.7231 7.19 12 7.19C10.2769 7.19 8.88 8.58687 8.88 10.31C8.88 12.0331 10.2769 13.43 12 13.43Z" stroke="currentColor" strokeWidth="1.5" />
                <path d="M3.62001 8.49C5.59001 -0.169998 18.42 -0.159997 20.38 8.5C21.53 13.58 18.37 17.88 15.6 20.54C13.59 22.48 10.41 22.48 8.39001 20.54C5.63001 17.88 2.47001 13.57 3.62001 8.49Z" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </div>
            <div className="info-content">
              <div className="info-label">Location</div>
              <div className="info-value" style={{ marginLeft: "-37px" }}>{foundEvent?.city?.city_name || "Not specified"}</div>
              <div className="info-subvalue">{foundEvent?.country?.country_name || ""}</div>
            </div>
          </div>

          {hasGuests && (
            <div className="info-card">
              <div className="info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M19.99 7.34C20.15 9.28 18.77 10.98 16.86 11.21C16.85 11.21 16.85 11.21 16.84 11.21H16.81C16.75 11.21 16.69 11.21 16.64 11.23C15.67 11.28 14.78 10.97 14.11 10.4C15.14 9.48 15.73 8.1 15.61 6.6C15.54 5.79 15.26 5.05 14.84 4.42C15.22 4.23 15.66 4.11 16.11 4.07C18.07 3.90 19.82 5.36 19.99 7.34Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21.99 16.59C21.91 17.56 21.29 18.4 20.25 18.97C19.25 19.52 17.99 19.78 16.74 19.75C17.46 19.1 17.88 18.29 17.96 17.43C18.06 16.19 17.47 15 16.29 14.05C15.62 13.52 14.84 13.1 13.99 12.79C16.2 12.15 18.98 12.58 20.69 13.96C21.61 14.7 22.08 15.63 21.99 16.59Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="info-content">
                <div className="info-label">Total Guests</div>
                <div className="info-value" style={{ marginLeft: "-60px" }}>{foundEvent.guest_list.length}</div>
                <div className="info-subvalue">Registered Attendees</div>
              </div>
            </div>
          )}
        </div>

        <div className={`content-grid ${!hasGuests ? 'no-sidebar' : ''}`}>
          <div className="content-main">
            <div className="content-section">
              <div className="section-header">
                <h2 className="section-title">About {isTrailer ? "Trailer" : "Event"}</h2>
              </div>
              <div className="section-body">
                <p className="event-description" style={{ marginBottom: foundEvent?.youtube_link ? '24px' : '0' }}>
                  {foundEvent?.about_event || "No description provided"}
                </p>

                {foundEvent?.youtube_link && (
                  <div className="youtube-link-container">
                    <div className="youtube-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M17 20H7C4 20 2 18 2 15V9C2 6 4 4 7 4H17C20 4 22 6 22 9V15C22 18 20 20 17 20Z" stroke="#FF0000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M11.4 9.5L13.9 11C14.8 11.6 14.8 12.5 13.9 13.1L11.4 14.6C10.4 15.2 9.59998 14.7 9.59998 13.6V10.6C9.59998 9.29999 10.4 8.89999 11.4 9.5Z" stroke="#FF0000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div className="youtube-content">
                      <div className="youtube-label">Watch on YouTube</div>
                      <a
                        href={foundEvent.youtube_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="youtube-watch-btn"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M17 20H7C4 20 2 18 2 15V9C2 6 4 4 7 4H17C20 4 22 6 22 9V15C22 18 20 20 17 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M11.4 9.5L13.9 11C14.8 11.6 14.8 12.5 13.9 13.1L11.4 14.6C10.4 15.2 9.6 14.7 9.6 13.6V10.6C9.6 9.3 10.4 8.9 11.4 9.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Watch Now
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {isTrailer && foundEvent?.three_sixty && foundEvent.three_sixty.length > 0 && (
              <div className="content-section">
                <div className="section-header">
                  <h2 className="section-title">360 VR Content ({foundEvent.three_sixty.length})</h2>
                </div>
                <div className="section-body">
                  <div className="vr-content-grid">
                    {foundEvent.three_sixty.map((content, index) => (
                      <div key={index} className="vr-item">
                        <div className="vr-header">
                          <h4 className="vr-title">{content.configuration}</h4>
                          {content.is_user_vr && (
                            <span className="vr-badge">VR Compatible</span>
                          )}
                        </div>
                        <div className="vr-iframe-container">
                          <iframe
                            src={content.iframe_url}
                            title={`VR Content ${index + 1}`}
                            style={{ width: "100%", height: "400px", border: "1px solid #e2e8f0", borderRadius: "8px" }}
                            allowFullScreen
                          />
                        </div>
                        <div className="vr-info">
                          <p className="vr-url">
                            <strong>URL:</strong> {content.iframe_url}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="two-column-grid">
              <div className="content-section">
                <div className="section-header">
                  <h2 className="section-title">{isTrailer ? "Trailer" : "Event"} Information</h2>
                </div>
                <div className="section-body">
                  <div className="details-table">
                    <div className="detail-row">
                      <div className="detail-label">{isTrailer ? "Trailer" : "Event"} Name</div>
                      <div className="detail-value">{foundEvent?.event_name || "—"}</div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-label">Type</div>
                      <div className="detail-value">{ToFirstCapital(foundEvent?.type) || "—"}</div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-label">Start Date</div>
                      <div className="detail-value">{formatDate(foundEvent?.start_date)}</div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-label">End Date</div>
                      <div className="detail-value">{formatDate(foundEvent?.end_date)}</div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-label">Start Time</div>
                      <div className="detail-value">{foundEvent?.start_time || "—"}</div>
                    </div>
                    <div className="detail-row">
                      <div className="detail-label">End Time</div>
                      <div className="detail-value">{foundEvent?.end_time || "—"}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="content-section">
                <div className="section-header">
                  <h2 className="section-title">Venue Details</h2>
                </div>
                <div className="section-body">
                  <div className="venue-details">
                    <div className="venue-address">
                      <div className="venue-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M10 11.1917C11.4359 11.1917 12.6 10.0276 12.6 8.59167C12.6 7.15573 11.4359 5.99167 10 5.99167C8.56406 5.99167 7.4 7.15573 7.4 8.59167C7.4 10.0276 8.56406 11.1917 10 11.1917Z" stroke="currentColor" strokeWidth="1.5" />
                          <path d="M3.01666 7.07499C4.65833 -0.141677 15.35 -0.133344 16.9833 7.08332C17.9417 11.3167 15.3083 14.9 13 17.1167C11.325 18.7333 8.675 18.7333 6.99166 17.1167C4.69166 14.9 2.05833 11.3083 3.01666 7.07499Z" stroke="currentColor" strokeWidth="1.5" />
                        </svg>
                      </div>
                      <div className="venue-info">
                        <div className="venue-label">Street Address</div>
                        <div className="venue-value">{foundEvent?.address || "Not specified"}</div>
                      </div>
                    </div>

                    <div className="venue-location-grid">
                      <div className="location-item">
                        <div className="location-label">Country</div>
                        <div className="location-value">{foundEvent?.country?.country_name || "—"}</div>
                      </div>
                      <div className="location-item">
                        <div className="location-label">State</div>
                        <div className="location-value">{foundEvent?.state?.state_name || "—"}</div>
                      </div>
                      <div className="location-item">
                        <div className="location-label">City</div>
                        <div className="location-value">{foundEvent?.city?.city_name || "—"}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {hasGuests && (
            <div className="content-sidebar">
              <div className="content-section sticky-section">
                <div className="section-header">
                  <h2 className="section-title">Featured Guests</h2>
                  <span className="guest-count">{foundEvent.guest_list.length}</span>
                </div>
                <div className="section-body">
                  <div className="guests-list-pro">
                    {foundEvent.guest_list.map((guest, index) => (
                      <div key={index} className="guest-card-pro">
                        <div className="guest-image-pro">
                          {guest?.image ? (
                            <img src={guest.image} alt={guest.name} />
                          ) : (
                            <div className="guest-avatar-pro">
                              {guest?.name?.charAt(0)?.toUpperCase() || "G"}
                            </div>
                          )}
                        </div>
                        <div className="guest-info-pro">
                          <h4 className="guest-name-pro">{guest?.name || "Guest"}</h4>
                          {guest?.designation && (
                            <p className="guest-designation">{guest.designation}</p>
                          )}
                          {guest?.organization && (
                            <p className="guest-organization">{guest.organization}</p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewEvents;